import AdminNavigation from './AdminNavigation';

export default AdminNavigation;
